export function formatEuro(amount: number) {
    if ('Intl' in window) {
        const euro = new Intl.NumberFormat('nl-NL', {
            style: 'currency',
            currency: 'EUR',
        });
        const result = euro.format(amount);
        if (result.endsWith(',00')) {
            return `${result.substring(0, result.length - 3)},-`;
        }
        return result;
    }
    return `€ ${amount.toLocaleString()}`;
}
